/*
 *
 * ErrorBoundary
 *
 * this component make react errors more readable
 */

import React, { Component } from 'react'
import PropTypes from 'prop-types'

class ErrorBoundary extends Component {
  constructor (props) {
    super(props)
    this.state = { hasError: false, error: '', errorInfo: '' }
  }

  static getDerivedStateFromError () {
    // Update state so the next render will show the fallback UI.
    return { hasError: true }
  }

  componentDidCatch (error, errorInfo) {
    // Catch errors in any components below and re-render with error message
    console.error('Uncaught error:', error, errorInfo)
    this.setState({ error, errorInfo })
  }

  render () {
    const { hasError, errorInfo, error } = this.state
    if (hasError) {
      return (
        <div className='bigbody'>
          <div className='errorbody'>
            <h2 data-testid='errorboundary'>Something went wrong.</h2>
            <br />
            <span>Here&apos;s the error: {error.toString()}</span>
            <details className='detailsbutton'>
              {errorInfo ? errorInfo.componentStack : <h3>Sorry, no more details</h3>}
            </details>
          </div>
        </div>
      )
    }
    return this.props.children
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.element
}

ErrorBoundary.defaultProps = {
  children: React.createElement('div')
}

export default ErrorBoundary
